import React, { useEffect, useState } from "react";
import { Container, Card } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdAddPhotoAlternate, MdDelete, MdEdit } from "react-icons/md";
import { IconButton } from "@mui/material";
import { Button, Input, Spin, Modal, Select, Switch, Pagination } from "antd";
import { getValue, phoneFormat } from "../../../services/functions";
import CountUp from "react-countup";
import { Message, ViewInput } from "../../../GlobalStyles";
import { ExclamationCircleFilled } from "@ant-design/icons";
import userPhoto from "../../../images/user.png";

const { confirm } = Modal;

export default function TecnicosAdmin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [visibleModalUsers, setVisibleModalUsers] = useState(false);
  const [enabled, setEnabled] = useState(true);
  const [tecnicos, setTecnicos] = useState([]);
  const [usersCollaborator, setUsersCollaborator] = useState([]);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [filtername, setFilterName] = useState("");
  const [tecnicosTotal, setTecnicosTotal] = useState(0);
  const [name, setName] = useState("");
  const [phone_number, setPhone_number] = useState("");
  const [email, setEmail] = useState("");
  const [photo, setPhoto] = useState("");
  const [page, setPage] = useState(0);
  const [users, setUsers] = useState([]);
  const [user_id, setUser_id] = useState("");
  const [password, setPassword] = useState("");
  const [sector, setSector] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    listTecnicos();
    listFranqueados();
  }, []);

  async function listFranqueados() {
    await api
      .get(`/users/all?all=true`)
      .then((response) => {
        let users = response.data.users;
        users.map((item) => {
          item.label = item.name;
          item.value = item.id;
        });
        setUsers(users);
      })
      .catch((response) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setFilterName("");
  }

  async function listTecnicos() {
    setLoading(true);
    await api
      .get(`/collaborators`)
      .then((response) => {
        setTecnicos(response.data.collaborators);
        setTecnicosTotal(response.data.collaboratorsTotal);
      })
      .catch(({ response }) => {
        if (response?.data?.message) {
          toast.warn(response.data.message);
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function loadUsersCollaborator(id) {
    await api
      .get(`/users-collaborator/${id}`)
      .then((response) => {
        setUsersCollaborator(response.data);
        setVisibleModalUsers(true);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function createAndEditTecnico() {
    setIsLoadingModal(true);
    if (id) {
      if (!name || !email || !phone_number || !sector) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("phone_number", phone_number);
        data.append("password", password);
        data.append("enabled", enabled);
        data.append("user_id", user_id);
        data.append("email", email.toLowerCase().replace(/ /g, ""));
        data.append("sector", sector);
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .put(`/collaborator/${id}`, data)
          .then(async (ok) => {
            toast.success("Técnico editado com sucesso");
            listTecnicos();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    } else {
      if (!name || !email || !password || !phone_number) {
        toast.warn("Preencha todos os campos para realizar o cadastro");
      } else {
        const data = new FormData();
        data.append("name", name);
        data.append("phone_number", phone_number);
        data.append("password", password);
        data.append("enabled", enabled);
        data.append("email", email.toLowerCase().replace(/ /g, ""));
        data.append("user_id", user_id);
        data.append("sector", sector);
        if (photo.name) {
          data.append("file", photo, photo.name);
        }
        await api
          .post(`/collaborator`, data)
          .then(async (ok) => {
            toast.success("Técnico criado com sucesso");
            listTecnicos();
            setVisibleModal(false);
          })
          .catch(({ response }) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente",
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente",
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteTecnico(id) {
    await api
      .delete(`/collaborator/${id}`)
      .then(() => {
        toast.success("Técnico excluido com sucesso");
        listTecnicos();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Técnicos</h1>

      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp duration={1} end={tecnicosTotal} />
          </Card>
          <div className="filter">
            <ViewInput style={{ width: 300 }}>
              <p>Pesquisar</p>
              <Input.Search
                value={filter}
                onChange={(text) => {
                  setFilter(text.target.value);
                }}
                placeholder="pesquisar"
                onSearch={(text) => {
                  setFilterSearch(text);
                  if (page) {
                    setPage(0);
                  } else {
                    listFranqueados(0, filterSearch);
                  }
                }}
                allowClear
                onClear={() => {
                  setFilterSearch("");
                  if (page) {
                    setPage(0);
                  }
                  setFilter("");
                }}
                enterButton
              />
            </ViewInput>
            <Button
              type="primary"
              style={{
                marginTop: 17,
                marginLeft: 50,
                borderRadius: 50,
              }}
              onClick={() => {
                setId("");
                setName("");
                setEmail("");
                setUser_id("");
                setEnabled(true);
                setPassword("");
                setPhoto("");
                setPhone_number("");
                setSector("");
                setVisibleModal(true);
              }}
            >
              Novo Técnico
            </Button>
          </div>
          {tecnicos.length == 0 && <Message>Nenhum técnico encontrado</Message>}
          <div className="orders">
            {tecnicos.map((item) => {
              return (
                <div className="order">
                  <img src={item.photo ? item.photo_url : userPhoto} />
                  <div className="infos">
                    <p>
                      {item.name} - {phoneFormat(item.phone_number)}
                    </p>
                    <p style={{ color: "#0008", marginTop: 5 }}>{item.email}</p>
                    <p style={{ color: "#000a", marginTop: 5 }}>
                      Setor: {item.sector}
                    </p>
                    <p style={{ color: "#000a", marginTop: 5 }}>
                      {getValue(item.totalWeek || 0)} em OSs nos últimos 7 dias
                    </p>
                  </div>
                  <div className="actions">
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate(`/admin/orders?tecnico=${item.id}`);
                      }}
                    >
                      OSs
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        navigate(`/admin/financeiro-tecnico/${item.id}`);
                      }}
                    >
                      Financeiro
                    </Button>
                    <Button
                      type="primary"
                      onClick={async () => {
                        await loadUsersCollaborator(item.id);
                      }}
                    >
                      Franqueados
                    </Button>
                    <Button
                      type="primary"
                      className="warning-button"
                      onClick={() => {
                        setId(item.id);
                        setName(item.name);
                        setEmail(item.email);
                        setEnabled(item.enabled);
                        setUser_id(item.user_id);
                        setPhoto({ photo_url: item.photo_url });
                        setPhone_number(item.phone_number);
                        setPassword("");
                        setSector(item.sector);
                        setVisibleModal(true);
                      }}
                    >
                      <MdEdit color="#FFF" size={20} />
                      Editar
                    </Button>
                    <Button
                      type="primary"
                      className="delete-button"
                      onClick={() => {
                        confirm({
                          okText: "Confirmar",
                          title: `Deseja excluir o Técnico ${item.name}?`,
                          icon: <ExclamationCircleFilled />,
                          content: `O técnico será excluido e perderá o acesso ao sistema`,
                          onOk() {
                            deleteTecnico(item.id);
                          },
                          onCancel() {},
                          cancelText: "Cancelar",
                        });
                      }}
                    >
                      <MdDelete color="#FFF" size={20} />
                      Exluir
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>

          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={tecnicosTotal}
          />
        </>
      )}

      <Modal
        title="Técnico"
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={id ? "EDITAR TÉCNICO" : "CADASTRAR TÉCNICO"}
        cancelText="FECHAR"
        onOk={() => {
          createAndEditTecnico();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              marginTop: 0,
              width: 260,
              height: 160,
              borderRadius: 10,
              marginBottom: 25,
              marginBottom: 20,
              justifyContent: "center",
            }}
          >
            <img
              style={{
                width: 160,
                marginLeft: 50,
                height: 160,
                borderRadius: 10,
                background: "#fff",
              }}
              src={photo.photo_url ? photo.photo_url : userPhoto}
            />
            <IconButton style={{ width: 50, height: 50, bottom: 15 }}>
              <label
                for="avatar"
                style={{
                  display: "flex",
                  width: 50,
                  height: 50,
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <MdAddPhotoAlternate color="#000" />
                <input
                  id="avatar"
                  style={{ display: "none" }}
                  type="file"
                  accept="image/"
                  onChange={(file) => {
                    let photo = file.target.files[0];
                    photo.photo_url = URL.createObjectURL(file.target.files[0]);
                    setPhoto(photo);
                  }}
                />
              </label>
            </IconButton>
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <ViewInput>
              <p>Nome*</p>
              <Input
                placeholder="nome"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </ViewInput>
            <ViewInput style={{ width: "100%" }}>
              <p>Setor</p>
              <Select
                placeholder="selecionar setor"
                value={sector || null}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setSector(value);
                }}
              >
                <Select.Option value={"Todos"}>Todos</Select.Option>
                <Select.Option value={"Serviços de segurança do Trabalho"}>
                  Serviços de segurança do Trabalho
                </Select.Option>
                <Select.Option value={"Revenda de treinamentos online"}>
                  Revenda de treinamentos online
                </Select.Option>
                <Select.Option value={"Serviços Medicina ocupacional"}>
                  Serviços Medicina ocupacional
                </Select.Option>
                <Select.Option value={"Credenciamento SST"}>
                  Credenciamento SST
                </Select.Option>
                <Select.Option value={"Assinatura Documentos SST"}>
                  Assinatura Documentos SST
                </Select.Option>
              </Select>
            </ViewInput>
            <ViewInput style={{ width: "100%" }}>
              <p>Vincular a um franqueado</p>
              <Select
                placeholder="selecionar franqueado"
                value={user_id || null}
                showSearch
                optionFilterProp="children"
                style={{ width: "100%", textAlign: "left" }}
                onChange={(value) => {
                  setUser_id(value);
                }}
              >
                {users.map((item) => {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                })}
              </Select>
            </ViewInput>
            <ViewInput>
              <p>Email*</p>
              <Input
                placeholder="suario@gmail.com"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>Telefone*</p>
              <Input
                placeholder="(00) 0000-0000"
                value={phone_number}
                onChange={(event) => setPhone_number(event.target.value)}
              />
            </ViewInput>
            <ViewInput>
              <p>{id ? "Nova Senha" : "Senha*"}</p>
              <Input
                placeholder={"****"}
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </ViewInput>
            <ViewInput
              style={{
                width: "49%",
              }}
            >
              <p>Receber OS automaticamente?</p>
              <div style={{ width: "100%", display: "flex" }}>
                <Switch
                  type="primary"
                  value={enabled}
                  style={{ justifySelf: "flex-start" }}
                  onChange={(text, type) => {
                    setEnabled(!enabled);
                  }}
                />
              </div>
            </ViewInput>
          </div>
        </div>
      </Modal>
      <Modal
        title={usersCollaborator.length + " Franqueados vinculados"}
        width={500}
        open={visibleModalUsers}
        cancelText="FECHAR"
        okButtonProps={{
          style: {
            display: "none",
          },
        }}
        onCancel={() => {
          setVisibleModalUsers(false);
        }}
      >
        <div
          style={{
            paddingTop: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <h3 style={{ textAlign: "center", color: "#fff" }}>
            {usersCollaborator.length} Franqueados vinculados
          </h3>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                color: "#000",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "left",
                marginBottom: 10,
              }}
            >
              {usersCollaborator.map((item, index) => {
                return (
                  <p style={{ marginBottom: 4, width: "100%" }}>
                    {index + 1}. {item.name}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </Modal>
    </Container>
  );
}
